<mat-dialog-content>
<div class="country-choose">
    <img src="../assets/map.jpg" class="map-image"/>
    <div class="title">Выберите Вашу страну</div>

    <mat-radio-group
            class="radio-group"
            [(ngModel)]="selectedCountry">
        <mat-radio-button class="radio-button" *ngFor="let country of countries" [value]="country">
            <div class="radio-button-label">
                <img src="../assets/icons/countries/{{country}}.png" class="country-image"/>

                {{countryNames[country]}}
            </div>
        </mat-radio-button>
    </mat-radio-group>
    <button class="main-button  cancel country-choose-button"
            mat-button [mat-dialog-close]="false"
            [disabled]="!selectedCountry"
            (click)="selectCountry()">Подтвердить</button>



</div>
    </mat-dialog-content>